import { network } from "../config";
import { StatisticResponse } from "../types/Statistic";
import TypeDefaultResponse from "../types/TypeDefaultResponse";
import url from "../utils/formApiUrl";
import customKy from "./kyExtend";

const { stats } = network;

const baseURL = process.env.REACT_APP_HTTP_CONNECTION_STRING + "statistics/";

const getAuthHeader = (token: string) => {
  return { Authorization: `Bearer ${token}` };
};

export default class StatisticApi {
  static async getAdminDashboardStats(token: string): Promise<
    TypeDefaultResponse & {
      statistics: StatisticResponse;
    }
  > {
    return await customKy
      .get(url(baseURL, stats.getAdminDashboardStats), {
        headers: getAuthHeader(token),
      })
      .then((res) => res.json());
  }

  static async getVerifiedSpecStatistic(token: string): Promise<
    TypeDefaultResponse & {
      statistics: StatisticResponse;
    }
  > {
    return await customKy
      .get(url(baseURL, stats.getVerifiedSpecStatistic), {
        headers: getAuthHeader(token),
      })
      .then((res) => res.json());
  }

  static async downloadClientMetadataTable(
    token: string,
    payload: {
      firstVisitDate?: { from: Date; to: Date };
      registerDate?: { from: Date; to: Date };
    } = {},
  ): Promise<string> {
    const response = await customKy.post(
      url(baseURL, stats.downloadClientMetadataTable),
      {
        headers: getAuthHeader(token),
        json: payload,
      },
    );

    return await response.text();
  }

  static async downloadSessionMetadataTable(
    token: string,
    payload: {
      sessionDate: { from?: Date; to?: Date };
    } = { sessionDate: {} },
  ): Promise<string> {
    const response = await customKy.post(
      url(baseURL, stats.downloadSessionMetadataTable),
      {
        headers: getAuthHeader(token),
        json: payload,
      },
    );

    return await response.text();
  }
}
